// extracted by mini-css-extract-plugin
export default {"results":"search-results_results__cpjQJ","loader":"search-results_loader__hGkba"};